import { useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/common/PageHeader";
import { UploadLimitBanner } from "../components/common/UploadLimitBanner";
import { ProjectScopeBanner } from "../components/common/ProjectScopeBanner";
import { OpsWizard } from "../components/common/OpsWizard";
import { DataTable } from "../components/common/DataTable";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function OpeningMigration() {
  const [rk] = useState(0);
  const columns = [
    { key: "id", label: "Batch", mono: true, render: (r) => <span className="font-mono text-xs">{r.id.slice(-8)}</span> },
    { key: "project_name", label: "Project" },
    { key: "type_name", label: "Type" },
    { key: "file_name", label: "File", hideMobile: true },
    { key: "total", label: "Total" },
    { key: "migrated", label: "Migrated" },
    { key: "rejected", label: "Rejected" },
    { key: "uploaded_by", label: "By", hideMobile: true },
    { key: "applied_at", label: "Applied", render: (r) => (r.applied_at || "").slice(0, 19).replace("T", " ") },
  ];
  return (
    <div>
      <PageHeader title="Opening Material Status Migration" subtitle="Set existing materials to their real opening operational status (GRN / Store / Field User / Installed) — one honest migration event, no fake lifecycle" />
      <UploadLimitBanner kind="opening" />
      <ProjectScopeBanner requireProject action="opening status migration" />
      <Tabs defaultValue="migrate">
        <TabsList>
          <TabsTrigger value="migrate" data-testid="opening-tab-migrate">Migrate</TabsTrigger>
          <TabsTrigger value="register" data-testid="opening-tab-register">Migration Register</TabsTrigger>
        </TabsList>
        <TabsContent value="migrate" className="mt-4">
          <OpsWizard
            testid="opening"
            needsType
            templateUrl="/materials/opening-migration/template"
            previewUrl="/materials/opening-migration/preview"
            applyUrl="/materials/opening-migration/apply"
            rejectedUrlBase="/materials/opening-migration/rejected"
            applyLabel={(n) => `Migrate ${n} materials`}
            extraNote="Materials must already exist (created via Material Upload). Target Status comes from the template per row. One OPENING_STATUS_MIGRATION event is recorded; no fake GRN/allocation/ack/install events. Materials with live ERP activity are blocked."
          />
        </TabsContent>
        <TabsContent value="register" className="mt-4">
          <DataTable testid="opening-register" columns={columns} refreshKey={rk} load={(params) => api.get("/materials/opening-migration/batches", { params }).then((r) => r.data)} searchPlaceholder="Search..." />
        </TabsContent>
      </Tabs>
    </div>
  );
}
